module.exports = __webpack_public_path__ + "public/files/img/success.cf3c701d.gif";